import React, { ComponentType, useContext } from 'react';
import { LinkContext } from '../Contexts/LinkContext';
import { LinkProps } from '../../containers/Link/types';

export const RouteLink: ComponentType<LinkProps> = (props) => {
  const Link = useContext(LinkContext);

  return <Link {...props} />;
};
